// @flow

// This is the baby list item on the intake list summary

import * as React from "react"
import {Link} from "react-router-dom"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {find} from "lodash"
import ClassNames from "classnames"

import FreeProductEditModal from "../modals/free-product-edit"
import ProductListItemSettings from "../product-list-item-settings"
import Icon from "../icon"
import {calcPrice} from "../../reducers/baby"
import type {
  BabyList,
  BabyListItem,
  ProductOrSet,
  ProductSet,
  State as ReduxState,
} from "../../types"

type Props = {
  +item: BabyListItem,
  +babyToken?: string,
  +className: string,
  +product: ProductOrSet,
  +onRemove: (number) => void,
  +onUpdate: (BabyListItem) => void,
  +noToggle?: boolean,
  +noDelete?: boolean,
  +showSettings: boolean,

  +babyList: BabyList,
  +t: any,
}

type State = {
  +showSettings: boolean,
  +isModalOpen: boolean,
}

class IntakeBabyListItem extends React.Component<Props, State> {
  handleToggleSettings: () => void
  handleRemove: () => void
  handleUpdate: (BabyListItem) => void

  handleFreeProductEdit: () => void
  handleCloseModal: () => void
  handleAfterOpen: () => void

  static defaultProps = {
    className: "",
    showSettings: false,
  }

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {
      showSettings: props.showSettings,
      noToggle: false,
      isModalOpen: false,
      noDelete: false,
    }

    this.handleRemove = this.handleRemove.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleToggleSettings = this.handleToggleSettings.bind(this)

    this.handleFreeProductEdit = this.handleFreeProductEdit.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)
  }

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (nextProps.showSettings == true) {
      return {...prevState, showSettings: true}
    }
    return prevState
  }

  handleRemove() {
    const {onRemove, item} = this.props
    onRemove(item.id)
  }

  handleUpdate(item: BabyListItem) {
    const {onUpdate} = this.props
    onUpdate(item)
  }

  handleToggleSettings() {
    const {item, noToggle} = this.props
    if (!item.isEditableOnIntake || noToggle) {
      return
    }
    this.setState({showSettings: !this.state.showSettings})
  }

  handleFreeProductEdit() {
    this.setState({isModalOpen: true})
  }

  handleCloseModal() {
    this.setState({isModalOpen: false})
  }

  handleAfterOpen() {}

  renderModal() {
    const {isModalOpen} = this.state
    if (!isModalOpen) {
      return null
    }
    const {item, babyToken, product} = this.props
    return (
      <FreeProductEditModal
        handleCloseModal={this.handleCloseModal}
        handleAfterOpen={this.handleAfterOpen}
        item={item}
        product={product}
        babyToken={babyToken}
      />
    )
  }

  renderSetItems(items: $ReadOnlyArray<BabyListItem>) {
    const {t, onRemove, onUpdate, babyList, product: productSet} = this.props
    const ps = (productSet: ProductSet)
    return (
      <div className="set-items">
        {items.map((item) => {
          const setProduct = find(
            ps.products,
            (p) => p.product.id === item.productId
          )
          const product = setProduct ? setProduct.product : null
          return (
            <IntakeBabyListItem
              key={`psi-${item.id}`}
              className="is-set-item"
              item={item}
              t={t}
              babyList={babyList}
              noToggle={!ps.isDivisible}
              noDelete={true}
              product={product || productSet}
              onRemove={onRemove}
              onUpdate={onUpdate}
            />
          )
        })}
      </div>
    )
  }

  renderIconStub() {
    return <span className="intake-baby-list-item-icons-icon is-stub" />
  }

  renderIcons() {
    const {item, product, noDelete, t, babyToken} = this.props
    let setLink = null
    if (babyToken && product.isSet) {
      const {categoryId, id} = product
      setLink = `/intake/${babyToken}/categories/${categoryId}/ps${id}`
    }
    return (
      <div className="intake-baby-list-item-icons">
        {!item.canInvoice ? (
          <span className="intake-baby-list-item-icons-icon is-xxl badge badge-warning">
            {t("intake.listSummary.item.canNotInvoice")}
          </span>
        ) : (
          this.renderIconStub()
        )}
        {item.webshopSource ? (
          <span className="intake-baby-list-item-icons-icon is-xxl badge badge-medium">
            {item.webshopSource}
          </span>
        ) : (
          this.renderIconStub()
        )}
        {product.isExternal ? (
          <span className="intake-baby-list-item-icons-icon is-xl badge badge-light">
            {t("intake.listSummary.item.isExternal")}
          </span>
        ) : (
          this.renderIconStub()
        )}
        {item.isPimp ? (
          <span className="intake-baby-list-item-icons-icon">
            <Icon name="icon-brush" />
          </span>
        ) : (
          this.renderIconStub()
        )}
        {item.isStar ? (
          <span className="intake-baby-list-item-icons-icon">
            <Icon name="icon-star" />
          </span>
        ) : (
          this.renderIconStub()
        )}
        {item.isRare ? (
          <span className="intake-baby-list-item-icons-icon">
            <Icon name="icon-warning-alt" />
          </span>
        ) : (
          this.renderIconStub()
        )}
        {setLink ? (
          <span className="intake-baby-list-item-icons-icon">
            <Link to={setLink} className="set-link">
              <Icon name="icon-forward" />
            </Link>
          </span>
        ) : (
          this.renderIconStub()
        )}
        {!item.isFirstPickup ? (
          <span className="intake-baby-list-item-icons-icon">
            <Icon name="icon-use-hand-truck" />
          </span>
        ) : (
          this.renderIconStub()
        )}
        {item.isExtra ? (
          <span className="intake-baby-list-item-icons-icon">
            <Icon name="icon-calculator" />
          </span>
        ) : (
          this.renderIconStub()
        )}
        {noDelete || !item.isEditableOnIntake ? (
          this.renderIconStub()
        ) : (
          <button
            className="intake-baby-list-item-icons-icon btn btn-icon btn-delete"
            onClick={this.handleRemove}
          >
            <Icon name="icon-trash" />
          </button>
        )}
      </div>
    )
  }

  render() {
    const {item, product, className, babyList} = this.props
    // if (item.id == 147342) {
    //   console.log(item)
    // }
    const {totalPriceNew, totalPriceSelling} = calcPrice(item, null, babyList)
    const classNames = ClassNames("intake-baby-list-item", className, {
      "out-estimate": !item.inEstimate,
      "is-zero": item.amount == 0,
      "is-editable-on-intake": item.isEditableOnIntake,
      "not-on-invoice": !item.canInvoice,
    })
    const classNamesName = ClassNames("intake-baby-list-item-name")
    const editFreeProductButton =
      product.categoryId == null ? (
        <button
          className="intake-baby-list-item-btn-free-edit"
          onClick={this.handleFreeProductEdit}
        >
          edit
        </button>
      ) : null
    return (
      <div className={classNames}>
        {this.renderModal()}
        <div className="row">
          <div
            className="col col-md-9 d-flex justify-content-between align-items-center main"
            onClick={this.handleToggleSettings}
          >
            <div className={classNamesName}>
              {product.name} <span>{product.subname}</span>
              {editFreeProductButton}
            </div>
            {this.renderIcons()}
          </div>
          <div className="col col-md-1 justify-content-center amount">
            {item.amount}
          </div>
          <div className="col col-md-1 justify-content-end price-col price-new">
            {item.isPriceTbd ? (
              <span className="badge badge-light">TBD</span>
            ) : (
              totalPriceNew.toFormat("$0,0.00")
            )}
          </div>
          <div className="col col-md-1 justify-content-end price-col">
            {item.isPriceTbd ? (
              <span className="badge badge-light">TBD</span>
            ) : (
              totalPriceSelling.toFormat("$0,0.00")
            )}
          </div>
        </div>
        {this.state.showSettings ? (
          <div className="row">
            <ProductListItemSettings
              babyListItem={item}
              product={product}
              onUpdate={this.handleUpdate}
            />
          </div>
        ) : null}
        {product.isSet && product.isDivisible && item.items
          ? this.renderSetItems(item.items)
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState): any => ({
  babyList: state.baby.list,
})

export default withTranslation()(connect(mapStateToProps)(IntakeBabyListItem))
